import React from "react";
import { fr } from "@/locales/fr";
import { appUrl } from "@/lib/referral";

/**
 * French mirror of StalenessBanner.jsx — same structure/behavior (shown
 * only when the entitlements fetch failed and the page is rendering the
 * last-known snapshot), copy translated into French (formal "vous").
 * Date formatting uses the "fr-FR" Intl locale so the month name itself
 * renders in French (e.g. "12 oct. 2026") instead of English.
 */
export const StalenessBannerFR = ({ lastUpdated }) => {
  const when = lastUpdated
    ? new Date(lastUpdated).toLocaleString("fr-FR", {
        year: "numeric",
        month: "short",
        day: "numeric",
      })
    : null;
  const t = fr.staleness;

  return (
    <div
      role="status"
      aria-live="polite"
      className="mb-10 border border-gold/40 bg-gold/[0.06] px-5 py-4 flex items-start gap-3"
      data-testid="entitlements-staleness-banner-fr"
    >
      <span
        className="mt-[6px] block w-1.5 h-1.5 rounded-full bg-gold flex-shrink-0"
        aria-hidden="true"
      />
      <p
        className="font-body italic text-sm text-nearblack/80 leading-relaxed"
        data-testid="entitlements-staleness-copy-fr"
      >
        {t.prefix}
        {when ? ` (${when})` : ""} — {t.notice}{" "}
        <a
          href={appUrl("https://work.voxiumscript.com", { lang: "fr" })}
          className="underline decoration-gold/60 underline-offset-2 hover:text-gold-600"
        >
          work.voxiumscript.com
        </a>{" "}
        {t.suffix}
      </p>
    </div>
  );
};

export default StalenessBannerFR;
